import { render, staticRenderFns } from "./standard-container.vue?vue&type=template&id=4317e4cc&functional=true&"
import script from "./standard-container.vue?vue&type=script&lang=js&"
export * from "./standard-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports